import { ReactNode, ComponentType } from 'react'
import { FilterType } from '~/context/filters'

export type FilterOption = {
  id: number | string
  value: any
  text: ReactNode
  subtext?: string
}

export type ComponentProps = {
  id: number
  value: any
  onChange: (value: any) => void
  type: keyof typeof FilterType
  filter: any
}

export type Filter = {
  /** A unique string */
  id: string
  title: ReactNode
  type?: 'list' | 'bu' | 'date_range' | 'time_range' | 'select'
  listType?: 'string' | 'number'
  config?: Record<string, any>
  options?: FilterOption[]
  preloadFromApi?: Record<string, any>
  optionsFromApi?: Record<string, any>
  valueLookupFromApi?: Record<string, any>
  placeholder?: string
  defaultIsOpen?: boolean
  defaultValue?: any
  component?: ComponentType<ComponentProps>
  allowedFor?: string[]
  queryParser?: (a: any) => any
  /** If this value is provided and set to false for a list-like filter, don't serialize the array to a string */
  joinValuesAsString?: boolean
}

// Just a way to get autocomplete in regular JS
export const typedFilters = (...filters: Filter[]) => filters
